var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-top",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop($event)}}},[_c('img',{attrs:{"src":require("../assets/images/backtop.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }